import { Component, OnInit } from '@angular/core';
import {DataserviceService} from '../../dataservice.service';
import * as $ from 'jquery';
import Swal from 'sweetalert2';
import {Router} from '@angular/router';


@Component({
  selector: 'app-updates',
  templateUrl: './updates.component.html',
  styleUrls: ['./updates.component.css']
})
export class UpdatesComponent implements OnInit {

height:Number;
windowHeight:Number;
// updates_listing1:Object[];
// updates_listing2:Object[];
updates_listing:Object[];
current_page = 1;
search = "";
page = 1;
collection = [];
type:Number;
collection_size:Number;
basePath:String;
value="";
  constructor(private dataservice:DataserviceService,private router:Router) { }






  ngOnInit(page=1,keyword="",type="") {
    console.log(page,keyword,type);
    
    this.basePath="http://18.224.22.40:3000/api/upload?filename=";
    this.current_page = page;
    this.windowHeight = innerHeight;
    console.log(this.windowHeight);
    
    var nnn = $('.header-section').innerHeight();
    var nnn1= $('.breadcrumb.breadcrumb-top').innerHeight();
    var nnn2 = $('.clearfix').innerHeight();
    this.height =innerHeight - nnn - nnn1 - nnn2 -3;



    this.dataservice.getUpdateList(page,keyword,type).subscribe(
      data =>{
        console.log(data);
        this.collection_size= data.total,

        // this.updates_listing1=data.local;
        // this.updates_listing2=data.social;
        // this.updates_listing = this.updates_listing1.concat(this.updates_listing2);
        this.updates_listing =data.updates;
        

        
      }
    )
  }


// update detail function start here
showUpdateDetailPage(data1){
 
  this.router.navigate(['/update-detail'], { queryParams: { id: data1 } });      

}

  removeUpdates(data,i){
    console.log(data);
    
    Swal({
      title: 'Delete Update',
      text: 'Are you sure,You want to remove  this update?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if(result.value){
        this.dataservice.removeUpdate(data).subscribe(
          data =>{
            this.updates_listing.splice(i,1)
            this.ngOnInit();
            
            console.log(data);
            
          }
        )
      }
    }); 
  
  }
  





}
